

































import {Component, Vue, Watch} from 'vue-property-decorator';
import LoadingDialog from '@/components/molecules/LoadingDialog.vue';
import ErrorDialog from '@/components/molecules/ErrorDialog.vue';
import ConfirmationDialog from '@/components/molecules/ConfirmationDialog.vue';
import PreviewDialog from '@/components/molecules/PreviewDialog.vue';
import HeaderImageDialog from '@/components/molecules/HeaderImageDialog.vue';
import UsersFormDialog from '@/components/molecules/UsersFormDialog.vue';
import appModule from '@/model/store/modules/app-module';
import detailModule from '@/model/store/modules/detail-module';
import headerModule from '@/model/store/modules/header-module';
import userModule from '@/model/store/modules/user-module';
import MainViewer from '@/views/MainViewer/MainViewer.vue';

@Component({
  components: {
    'loading-dialog': LoadingDialog,
    'error-dialog': ErrorDialog,
    'main-viewer': MainViewer,
    'confirmation-dialog': ConfirmationDialog,
    'preview-dialog': PreviewDialog,
    'header-image-dialog': HeaderImageDialog,
    'users-form-dialog': UsersFormDialog
  }
})
export default class App extends Vue {
  /** Refs **/
  public $refs!: {
    loadingDialog: LoadingDialog,
    errorDialog: ErrorDialog,
    confirmationDialog: ConfirmationDialog,
    previewDialog: PreviewDialog,
    headerImageDialog: HeaderImageDialog,
    usersFormDialog: UsersFormDialog
  };

  public icons: string[] = [
    'fab fa-twitter',
    'fab fa-instagram',
  ];

  /** Computed **/
  get isLoading() {
    return appModule.isLoading;
  }

  get isConfirmationDialog() {
    return appModule.isConfirmationDialog;
  }

  get isPreviewDialog() {
    return detailModule.isPreviewDialog;
  }

  get isHeaderDialog() {
    return headerModule.isHeaderDialog;
  }

  get isHeaderImageDialog() {
    return appModule.isHeaderImageDialog;
  }

  get isUsersFormDialog() {
    return userModule.isUsersFormDialog;
  }

  get isError() {
    return appModule.isError;
  }
  /** Watchers **/
  /*@Watch('$route')
  private onChangeRoute(to: {path: string}, from: {path: string}): void {
    console.log(to.path);
    console.log(from.path);
  }*/
  @Watch('isConfirmationDialog')
  private onIsConfirmationDialog(): void {
    this.$refs.confirmationDialog.open(appModule.isConfirmationDialog);
  }

  @Watch('isPreviewDialog')
  private onIsPreviewDialog(): void {
    this.$refs.previewDialog.open(detailModule.isPreviewDialog);
  }

  @Watch('isHeaderDialog')
  private onIsHeaderDialog(): void {
    this.$refs.headerImageDialog.open(headerModule.isHeaderDialog);
  }

  @Watch('isUsersFormDialog')
  private onIsUsersFormDialog(): void {
    this.$refs.usersFormDialog.open(userModule.isUsersFormDialog);
  }

  @Watch('isError')
  private onIsError(): void {
    this.$refs.errorDialog.open({
      state: appModule.isError.state,
      message: appModule.isError.message,
      status: appModule.isError.status
    });
  }

  /** Methods **/

  /**
   * 子コンポーネントから伝搬してきたErrorを使ってエラーダイアログの表示
   *
   * @param err {Error}
   */
  private errorCapture(err: Error): void {
    this.$refs.errorDialog.open({
      state: true,
      message: err.message
    });
  }

}
